'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (value && !/^(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/i.test(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var isValidPath = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!value[0]) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var _hasLengthGreaterThan = function _hasLengthGreaterThan(n) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      if (value.length <= n) {
        return message;
      }
    };
  }, function (field) {
    return field + ' must be greater than ' + n;
  });
};

var validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.composeValidators)(_revalidate.isRequired, _hasLengthGreaterThan(2))('Name'),

  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)('Email'),

  company: (0, _revalidate.composeValidators)(_revalidate.isRequired, _hasLengthGreaterThan(2))('Company'),

  industry: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Industry'),

  country: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Country'),

  position: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Position'),

  companyUrl: (0, _revalidate.composeValidators)(_revalidate.isRequired)('CompanyUrl'),

  comments: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))('Comments')

});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/EnterpriseProgramFormValidation.js
// module id = 2837
// module chunks = 0